import * as prismic from '@prismicio/client';

const REPOSITORY = process.env.REACT_APP_PRISMIC_REPOSITORY as string;
const TOKEN = process.env.REACT_APP_PRISMIC_ACCESS_TOKEN as string;

export const prismicClient = prismic.createClient(REPOSITORY, {
  accessToken: TOKEN,
});
